// @flow
export const normalizeName = (name: ?string): string => (
  (name && typeof name === 'string')
    ? name.trim().toLowerCase().replace('ё', 'e').replace(/[^а-я]+/g, '')
    : ''
);

type NameObject = {
  id?: string | number,
  first?: string,
  last?: string,
  gender?: string,
};

type NormalizedNameObject = {
  id?: string | number,
  normalizedFirst: string,
  normalizedLast: string,
  normalizedGender: string,
};

export const normalizeNameObject = ({ id, first, last, gender }: NameObject): NormalizedNameObject => ({
  id,
  normalizedFirst: normalizeName(first),
  normalizedLast: normalizeName(last),
  normalizedGender: (typeof gender === 'string') ? gender.trim().toLowerCase() : '',
});

export const compareStudents = (int: NormalizedNameObject, ext: NormalizedNameObject): bool => {
  // не можем сравнивать если нет имен или одного имени
  if (!(int.normalizedFirst && ext.normalizedFirst)) return false;

  // фамилии и пол сравниваем, если есть у обоих сравниваемых объектов
  return (
    int.normalizedFirst === ext.normalizedFirst
    && (int.normalizedLast && ext.normalizedLast ? int.normalizedLast === ext.normalizedLast : true)
    && (int.normalizedGender && ext.normalizedGender ? int.normalizedGender === ext.normalizedGender : true)
  );
};
